(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity/assets/react/components/charity-card.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity/assets/react/components/charity-card.js');

'use strict';

var _svs;
const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardHeader = _svs$ui$ReactCard.CardHeader,
  CardBody = _svs$ui$ReactCard.CardBody;
const cdn = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.cdn2.replace('/content', '');
const CharityCard = _ref => {
  let charity = _ref.charity,
    _ref$showThankfulMess = _ref.showThankfulMessage,
    showThankfulMessage = _ref$showThankfulMess === void 0 ? false : _ref$showThankfulMess;
  const logotypeId = charity.logotypeId,
    name = charity.name,
    thankfulMess = charity.thankfulMess,
    externalUrl = charity.externalUrl;
  return React.createElement(Card, {
    className: "lp-charity-card"
  }, React.createElement(CardHeader, null, logotypeId && React.createElement("div", {
    className: "card-charity-header-content"
  }, React.createElement("img", {
    className: "margin-top-1 margin-bottom-1",
    src: cdn + logotypeId,
    alt: "".concat(name, " logo")
  }))), showThankfulMessage ? React.createElement(CardBody, null, thankfulMess && React.createElement("p", null, thankfulMess), externalUrl && React.createElement("p", null, React.createElement("a", {
    href: externalUrl,
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "Bes\xF6k ", name), " f\xF6r mer information")) : '');
};
setGlobal('svs.lyckoplatsen.components.shared_charity.react.components', {
  CharityCard
});

 })(window);